import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function useGtagPageView(trackingId) {
  const location = useLocation();

  useEffect(() => {
    if (!window.gtag) return;

    window.gtag('config', trackingId, {
      page_path: location.pathname + location.search,
    });
  }, [location, trackingId]);
}

export default useGtagPageView;